import { roughlyEqual } from "utils/numbers";
import TimelinePositions from "../types/TimelinePositions";

export default function getDetailsAtAbsoluteTime(
  absoluteTime: number,
  positions: TimelinePositions,
) {
  if (!positions.startTimes || !positions.startTimesReversed) {
    positions.startTimes = Array.from(positions.keys());
    positions.startTimesReversed = [...positions.startTimes].reverse();
  }
  const { startTimes, startTimesReversed } = positions;

  const absoluteStartTimeOfTimelineItem = startTimesReversed.find(
    (startTime) =>
      roughlyEqual(startTime, absoluteTime) || startTime < absoluteTime,
  ) as number;

  const timelineItemIndex = Math.max(
    startTimes.findIndex((t) => t === absoluteStartTimeOfTimelineItem),
    0,
  );

  const timelineItem = positions.get(absoluteStartTimeOfTimelineItem);

  let relativeTime =
    absoluteTime -
    absoluteStartTimeOfTimelineItem +
    (timelineItem?.startTime || 0);
  if (relativeTime < 0) relativeTime = 0;

  return {
    ...timelineItem,
    timelineItemIndex,
    relativeTime,
  };
}
